import store from '@state/store'
import lazyLoadView from "./lazyload-view";
import routeError from "./route-error";
import formatProductType from '@utils/format-product-type'
import _find from 'lodash/find'

export default [
  {
    path: '/:merchantAlias/member/booking',
    name: 'member-order',
    component: () => lazyLoadView(import('@views/member/order')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentBooking,
            currentMerchant
          ] = await Promise.all([
            store.dispatch('booking/fetchOrders', {
              page: routeTo.query.p,
              status: routeTo.query.status,
              orderBy: routeTo.query.orderBy,
              merchantAlias: routeTo.params.merchantAlias,
            }),
            store.dispatch('merchant/fetchMerchant', {
              merchantAlias: routeTo.params.merchantAlias,
            })
          ]);

          routeTo.params.merchant = currentMerchant;
          routeTo.params.orders = currentBooking.items;
          routeTo.params.pagination = currentBooking.pagination;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      merchant: route.params.merchant || {},
      orders: route.params.orders || [],
      pagination: route.params.pagination || {},
    }),
  },
  {
    path: '/:merchantAlias/member/booking/:orderKey',
    name: 'member-order-item',
    component: () => lazyLoadView(import('@views/member/orderItem')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder
          ] = await Promise.all([
            store.dispatch('booking/fetchOrder', {
              orderKey: routeTo.params.orderKey
            }),
          ]);

          store.dispatch('merchant/updateMerchant', currentOrder.items.merchant);
          routeTo.params.member = store.state.auth.currentMember;
          routeTo.params.order = currentOrder.items;
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Merchant' } }));
        }
        next()
      },
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      member: route.params.member || {},
      order: route.params.order || {},
    }),
  },
  {
    path: '/:merchantAlias/member/booking/:orderKey/ticket',
    name: 'member-order-ticket',
    component: () => lazyLoadView(import('@views/member/orderTicket')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder,
            currentTickets
          ] = await Promise.all([
            store.dispatch('booking/fetchOrder', {
              orderKey: routeTo.params.orderKey,
            }),
            store.dispatch('booking/fetchOrderTickets', {
              orderKey: routeTo.params.orderKey
            }),
          ]);

          // 燈種不能進
          if(formatProductType('category', currentOrder.items.productType) === 'light') {
            next({
              name: 'member-order-item',
              params: {
                merchantAlias: routeTo.params.merchantAlias,
                orderKey: currentOrder.items.id,
              },
              query: {
                language: routeTo.query.language || routeFrom.query.language
              }
            })
          }

          store.dispatch('merchant/updateMerchant', currentOrder.items.merchant);

          routeTo.params.order = currentOrder.items;
          routeTo.params.tickets = currentTickets.items
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }

        next()
      },
      showLoginButton: true,
      authRequired: true,
    },
    props: (route) => ({
      order: route.params.order || {},
      tickets: route.params.tickets || {},
    }),
  },
  {
    path: '/:merchantAlias/member/booking/:orderKey/codes',
    name: 'member-order-code',
    component: () => lazyLoadView(import('@views/member/orderTicket')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const [
            currentOrder
          ] = await Promise.all([
            store.dispatch('booking/fetchOrder', {
              orderKey: routeTo.params.orderKey,
            })
          ]);

          // 活動不能進
          if(formatProductType('category', currentOrder.items.productType) === 'activity') {
            next({
              name: 'member-order-item',
              params: {
                merchantAlias: routeTo.params.merchantAlias,
                orderKey: currentOrder.items.id,
              },
              query: {
                language: routeTo.query.language || routeFrom.query.language
              }
            })
          }

          routeTo.params.order = currentOrder.items;

          let tickets = [];
          let codeNum = 0;

          routeTo.params.order.params.forEach((param) => {
            const codes = () => {
              const codes = [];

              const ticketField = (index, key, type = 'type') => {
                if(!routeTo.params.order.customerInfos[index]) {
                  return ''
                }

                const ticket = Object.values(routeTo.params.order.customerInfos[index].bySizeExtrafields || {});

                const field = _find(ticket, (item) => (item[type] === key && item.default));

                return field ? field.value : '';
              };

              for(let j = 0; j < param.qty; j++) {
                codes.push({
                  "fullName": ticketField(codeNum, 'name') || ticketField(codeNum, 'company'),
                  "birth": ticketField(codeNum, 'birth'),
                  "address": ticketField(codeNum, 'address'),
                  "id": ticketField(codeNum, 'serial_number'),
                  "image": ticketField(codeNum, 'light_image')
                });

                codeNum ++
              }

              return codes
            };

            tickets.push({
              "name": param.name,
              "introtext": param.introtext,
              "size": param.size,
              "qty": param.qty,
              "codes": codes()
            })
          });

          routeTo.params.tickets = tickets;

          store.dispatch('merchant/updateMerchant', currentOrder.items.merchant);

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404', params: { resource: 'Order' } }));
        }
      },
      showLoginButton: true,
      authRequired: false,
    },
    props: (route) => ({
      order: route.params.order || {},
      tickets: route.params.tickets || [],
    }),
  },
]
